import { render } from "./DocHubObject.vue?vue&type=template&id=238c6e88&scoped=true"
import script from "./DocHubObject.vue?vue&type=script&lang=js"
export * from "./DocHubObject.vue?vue&type=script&lang=js"

import "./DocHubObject.vue?vue&type=style&index=0&id=238c6e88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238c6e88"]])

export default __exports__